import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const rows = [createData('Austin', 159, 6.0, 24), createData('Tokyo', 237, 9.0, 37), createData('Cork', 262, 16.0, 24)];

const Locaciones = () => {
  return (
    <>
      <section>
        <div
          className="flex-col bg-white m-10 rounded-lg mt-0 border-r border-b border-l border-gray-400 lg:border-t lg:border-gray-400 bg-white rounded-b lg:rounded-b-none lg:rounded-r border-gray-400"
          style={{ margin: '20px 10px 10px 10px', height: '18vh' }}
        >
          <p className="p-10 font-medium">Todas las Locaciones</p>
          <TableContainer component={Paper} sx={{ height: '11vh', maxWidth: '98%', overflowY: 'auto', margin: '5px' }}>
            <Table aria-label="caption table">
              <TableHead style={{ backgroundColor: 'lightgray' }}>
                <TableRow>
                  <TableCell>Location</TableCell>
                  <TableCell align="right">Transactions</TableCell>
                  <TableCell align="right">Versión</TableCell>
                  <TableCell align="right">Current</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow key={row.name}>
                    <TableCell component="th" scope="row">
                      {row.name}
                    </TableCell>
                    <TableCell align="right">{row.calories}</TableCell>
                    <TableCell align="right">{row.fat}</TableCell>
                    <TableCell align="right">{row.carbs}</TableCell>
                    <TableCell align="right">{row.protein}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        <div
          className="flex-col bg-white m-10 rounded-lg mt-0 border-r border-b border-l border-gray-400 lg:border-t lg:border-gray-400 bg-white rounded-b lg:rounded-b-none lg:rounded-r border-gray-400"
          style={{ margin: '20px 10px 10px 10px', height: '13vh' }}
        >
          <p className="p-10 font-medium">Transacciones con problemas</p>
          <TableContainer component={Paper} sx={{ height: '8vh', maxWidth: '98%', overflowY: 'auto', margin: '2px' }}>
            <Table aria-label="caption table">
              <TableHead style={{ backgroundColor: 'lightgray' }}>
                <TableRow>
                  <TableCell>Location</TableCell>
                  <TableCell align="right">Transactions</TableCell>
                  <TableCell align="right">Versión</TableCell>
                  <TableCell align="right">Current</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow key={row.name}>
                    <TableCell component="th" scope="row">
                      {row.name}
                    </TableCell>
                    <TableCell align="right">{row.calories}</TableCell>
                    <TableCell align="right">{row.fat}</TableCell>
                    <TableCell align="right">{row.carbs}</TableCell>
                    <TableCell align="right">{row.protein}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </section>
    </>
  );
};

export default Locaciones;
